import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M8.6 5.4L6.8 5l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 5l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.8 1.7.8c.4.2.6 0 .6-.4l-.3-2 1.3-1.4c.3-.3.2-.6-.2-.7zM8.6 14.4L6.8 14l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 14l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7zM8.6 23.4L6.8 23l-1-1.7c-.1-.4-.5-.4-.7 0L4.2 23l-1.8.3c-.4.1-.5.5-.2.8l1.3 1.4-.3 2c0 .4.2.6.6.4l1.7-.9 1.7.9c.4.2.6 0 .6-.5l-.3-1.9 1.3-1.4c.3-.3.2-.7-.2-.7z"/><rect x="13" y="5" width="17" height="4" rx="2"/><rect x="13" y="14" width="17" height="4" rx="2"/><rect x="13" y="23" width="17" height="4" rx="2"/>';
export var FactsFeaturesSVG = function FactsFeaturesSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FactsFeaturesSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FactsFeaturesSVG);